<script>
    import * as d3 from "d3";
    import {onMount} from 'svelte';
    export let data_calls, data_employees, data_aban_rate;

    let containerOne, containerTwo, containerThree;
    let height = 160;

    onMount(() => {

       function drawBars(data, container, color, tickFormat) {
            let svg = d3.select(container);

            svg.html("");

            svg.attr("class", "bar-chart")
                .attr("height", height);

            const margin = {top: 10, right: 10, bottom: 20, left: 26},
                width = svg.node().getBoundingClientRect().width, 
                widthInner = width - margin.left - margin.right,
                heightInner = height - margin.top - margin.bottom;

            svg.attr("width", width)

            var x = d3.scaleBand()
                .domain(["2018", "'19", "'20", "'21", "'22"])
                .range([ 0, widthInner ])
                .paddingInner(0.1);

            var y = d3.scaleLinear()
                .domain([0, d3.max(data, function(d) { return +d.value; })])
                .range([ heightInner, 0 ]);

            let g = svg
                .append("g")
                .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

            // Add y axis
            const yAxis = d3.axisLeft().scale(y)
                .ticks(4)
                .tickFormat(d3.format(tickFormat))
                .tickSize(-innerWidth);

            g.append("g")
                .attr("class", "axis y")
                .call(yAxis);

            // Add x axis
            const xAxis = d3.axisBottom().scale(x)
            // .tickFormat(d3.timeFormat('%b.'));

            g.append("g")
                .attr("transform", "translate(0," + heightInner + ")")
                .attr("class", "axis x")
                .call(xAxis);

            g.selectAll(".bar")
                .data(data)
                .enter()
                .append("rect")
                .attr("class","bar")
                .attr("x", d => x(d.year))
                .attr("y", d => y(d.value))
                .attr("width", x.bandwidth())
                .attr("height", d => heightInner - y(d.value))
                .attr("fill", color);
        };

        function drawAll() {
            drawBars(data_calls, containerOne, "#55A4DD", '.2s');
            drawBars(data_employees, containerTwo, "#E9BB62", '.2s');
            drawBars(data_aban_rate, containerThree, "#D593EC", '.0%');
        }

        drawAll();
        window.addEventListener('resize', drawAll);


    })

</script>

<div aria-hidden="true">
    <h3>Calls received</h3>
    <div class="unit-label">Per fiscal year</div>
    <svg bind:this={containerOne}></svg>
</div>
<div aria-hidden="true">
    <h3>Full time employees</h3>
    <div class="unit-label">Per fiscal year</div>
    <svg bind:this={containerTwo}></svg>
</div>
<div aria-hidden="true">
    <h3>Abandonment rate</h3>
    <div class="unit-label">Per fiscal year</div>
    <svg bind:this={containerThree}></svg>
</div>